import { bookingDotComChargeBasesEnum } from 'models/PropertyFees';
import { BOOKING_PERCENT_APPLIES_TO_OPTIONS } from './PropertyFeeModal.constants';

export const getBookingDotComChargeBasesFromPercentAppliesTo = (
  percentAppliesTo: BOOKING_PERCENT_APPLIES_TO_OPTIONS,
) => {
  const BOOKING_DOT_COM_CHARGE_BASES_OPTIONS_MAPPING = {
    [BOOKING_PERCENT_APPLIES_TO_OPTIONS.RENT_ONLY]: [
      bookingDotComChargeBasesEnum.NET_ROOM_PRICE,
    ],
    [BOOKING_PERCENT_APPLIES_TO_OPTIONS.RENT_LOCALITY]: [
      bookingDotComChargeBasesEnum.NET_ROOM_PRICE,
      bookingDotComChargeBasesEnum.LOCALITY_CHARGES,
    ],
    [BOOKING_PERCENT_APPLIES_TO_OPTIONS.RENT_PROPERTY]: [
      bookingDotComChargeBasesEnum.NET_ROOM_PRICE,
      bookingDotComChargeBasesEnum.PROPERTY_CHARGES,
    ],
    [BOOKING_PERCENT_APPLIES_TO_OPTIONS.RENT_LOCALITY_PROPERTY]: [
      bookingDotComChargeBasesEnum.NET_ROOM_PRICE,
      bookingDotComChargeBasesEnum.PROPERTY_CHARGES,
      bookingDotComChargeBasesEnum.LOCALITY_CHARGES,
    ],
  };

  return BOOKING_DOT_COM_CHARGE_BASES_OPTIONS_MAPPING[percentAppliesTo];
};

export const getBookingPercentAppliesToFromChargeBases = (
  chargeBases: bookingDotComChargeBasesEnum[] | null | undefined,
): BOOKING_PERCENT_APPLIES_TO_OPTIONS | '' => {
  if (!chargeBases || chargeBases.length === 0) {
    return '';
  }

  if (
    chargeBases.includes(bookingDotComChargeBasesEnum.NET_ROOM_PRICE) &&
    chargeBases.includes(bookingDotComChargeBasesEnum.LOCALITY_CHARGES) &&
    chargeBases.includes(bookingDotComChargeBasesEnum.PROPERTY_CHARGES)
  ) {
    return BOOKING_PERCENT_APPLIES_TO_OPTIONS.RENT_LOCALITY_PROPERTY;
  }

  if (
    chargeBases.includes(bookingDotComChargeBasesEnum.NET_ROOM_PRICE) &&
    chargeBases.includes(bookingDotComChargeBasesEnum.LOCALITY_CHARGES)
  ) {
    return BOOKING_PERCENT_APPLIES_TO_OPTIONS.RENT_LOCALITY;
  }

  if (
    chargeBases.includes(bookingDotComChargeBasesEnum.NET_ROOM_PRICE) &&
    chargeBases.includes(bookingDotComChargeBasesEnum.PROPERTY_CHARGES)
  ) {
    return BOOKING_PERCENT_APPLIES_TO_OPTIONS.RENT_PROPERTY;
  }

  return BOOKING_PERCENT_APPLIES_TO_OPTIONS.RENT_ONLY;
};
